// extracted by mini-css-extract-plugin
export default {"icon":"supportcontacts_icon__1m3V7","input-row":"supportcontacts_input-row__EBrr2","input":"supportcontacts_input__uP+KO"};